<template>
  <form id="form-login-page">
    <div class="mb-3">
      <input
        type="email"
        class="form-control"
        id="form-email"
        placeholder="Email Address"
        v-model="email"
      />
    </div>
    <div class="mb-3">
      <input
        type="password"
        class="form-control"
        id="form-password"
        placeholder="Password"
        v-model="password"
      />
    </div>
    <div class="mb-3 text-center">
      <button type="submit" class="btn btn-primary text-center" @click.prevent="loginUser">Login</button>
    </div>
    <div>
      <!-- {{params}} -->
      <!-- <GoogleLogin :params="params" :renderParams="renderParams" :onSuccess="onSuccess"></GoogleLogin> -->
      <!-- <GLogin :params="params"
      :onSuccess="onSuccess"
      ></GLogin> -->
      <button type="submit" @click.prevent="googleLogin">Gooogle Login</button>
    </div>
  </form>
</template>

<script>
import Register from "../views/Register"
import GoogleLogin from 'vue-google-login';
import GLogin from 'vue-google-login'
export default {
    name: "FormLogin",
    // data() {
    //     return  {
    //     email: '',
    //     password: '',
    //     params: {
    //                 client_id: "99715008598-n0hqoe579li3q48llt4ptqh7vkhhb5l5.apps.googleusercontent.com"
    //             },
    //     renderParams: {
    //                 width: 250,
    //                 height: 50,
    //                 longtitle: true
    //             }
    //     }
    // },
    components: {
      Register,
      GoogleLogin,
      GLogin
    },
    data(){
      return{
        params: {
                    client_id: "99715008598-n0hqoe579li3q48llt4ptqh7vkhhb5l5.apps.googleusercontent.com"
                },
        renderParams: {
                    width: 250,
                    height: 50,
                    longtitle: true
                },
        email: '',
        password: '',
      }
    },
    methods: {
        loginUser(){
            const {email, password} = this
            this.$emit('clickLogin', {email, password})
        },
        changePage(data) {
          this.$emit('changePage', data)
        },
        onSuccess(googleUser) {
          console.log('masuk onsuccess');
          console.log(googleUser, '<<< googleUser');
        },
        googleLogin() {
          this.$gAuth.signIn()
          .then(user => {
            console.log(user);
          })
        }
    }
};
</script>

<style>
</style>